import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./EstructuraDeServicios.css";

const funciones = [
  "Función 1",
  "Función 2",
  "Función 3",
  "Función 4",
  "Función 5"
];

const ValidadorDePagos = () => {
  const [selectedImage, setSelectedImage] = useState(1);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
  };

  const handleThumbnailClick = (num) => {
    setSelectedImage(num);
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(num - 1);
    }
  };

  return (
    <div className="producto-detalle">
      <div className="fondo-validador">
        <img 
          src="/images/serviciosbackground.jpg" 
          alt="Imagen de fondo Validador de Pagos de Facturas"
        />
        <div className="fondo-validador-overlay"></div>
      </div>

      <header className="fade-in">
        <h1 className="titulo-validador">Validador de Pagos de Facturas</h1>
      </header>

      <section className="detalle-contenido fade-in">
        <img
          src={`/images/validadorcarrusel1.jpg`}
          alt="Validador de Pagos de Facturas 1"
          className="detalle-imagen"
        />
        <div className="descripcion">
          <p>
            Facilita la gestión de pagos pendientes con un sistema automatizado de aprobación. Este validador utiliza un circuito de firmas para garantizar que los pagos a proveedores sean revisados y aprobados sin esfuerzo.
          </p>
        </div>
      </section>

      <section className="funciones fade-in">
        <h2>Funciones Destacadas</h2>
        <ul>
          {funciones.map((funcion, index) => (
            <li key={index}>✓ {funcion}</li>
          ))}
        </ul>
      </section>

      <section className="carrusel fade-in">
        <h2>Galería</h2>
        <Slider {...settings} ref={sliderRef}>
          {[1, 2, 3, 4, 5].map((num) => (
            <div key={num}>
              <img
                src={`/images/validadorcarrusel${num}.jpg`}
                alt={`Validador ${num}`}
                className="carrusel-imagen"
              />
            </div>
          ))}
        </Slider>
      </section>

      <section className="album-miniaturas fade-in">
        <h2>Vista Completa</h2>
        <div className="album">
          {[1, 2, 3, 4, 5].map((num) => (
            <img
              key={num}
              src={`/images/validadorcarrusel${num}.jpg`}
              alt={`Validador ${num}`}
              className="miniatura"
              onClick={() => handleThumbnailClick(num)}
            />
          ))}
        </div>
      </section>

      <section className="cta fade-in">
        <h2>Prueba el Validador Ahora</h2>
        <p>Facilita la gestión de pagos de forma eficiente.</p>
        <button className="btn-cta">Solicitar una Demo</button>
      </section>
    </div>
  );
};

export default ValidadorDePagos;
